import React, { PureComponent } from "react";

import { withStyles} from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import Modal from "@material-ui/core/Modal";

const styles = {
  root: {
    marginLeft: "auto",
    marginRight: "auto",
    paddingTop: "35vh"
  },
  back: {
    margin: 0,
    width: "100%",
    maxWidth: "100%",
    height: "100%",
    maxHeight: "none",
    display: "flex"
  }
};


class Loading extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      show: false
    }
  }

  componentDidMount() {
    this.timer = setTimeout(this.setState({ show: true }), 500);
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
    this.setState({ show: false });
  }

  render() {

    const { classes } = this.props;

    if (!this.state.show) {
      return null;
    }

    return (
      <Modal open={true} hideBackdrop={true} >
        <div className={classes.back} >
          <div className={classes.root} >
            <CircularProgress size={40} />
          </div>
        </div>
      </Modal>
    );
  }
}

export default withStyles(styles)(Loading);
